import '@fancyapps/fancybox';
import ArrowLeft from '../../img/arrow-left.svg';
import ArrowRight from '../../img/arrow-right.svg';


function updateSlidesHeightToHighestSlide( swiper ) {
	const $swiper = $( swiper.el );
	const $slides = $( '.swiper-slide', $swiper );

	$swiper.css( 'height', '' );
	$slides.css( 'height', '' );

	let maxHeight = 0;
	$slides.each( function() {
		maxHeight = Math.max( maxHeight, $( this ).outerHeight( true ) );
	} );

	$swiper.css( 'height', maxHeight + '' );
	$slides.css( 'height', maxHeight + '' );
}

$( '.image-carousel-with-caption-container' ).each( function() {
	const $container = $( this );
	const $imageCarousel = $( '.image-carousel', $container );
	const $imageCaptionCarousel = $( '.image-caption-carousel', $container );

	const imageCarouselElement = $imageCarousel[ 0 ];
	const imageCaptionCarouselElement = $imageCaptionCarousel[ 0 ];

	if ( !imageCarouselElement || !imageCaptionCarouselElement ) {
		return;
	}

	const $imageCarouselNext = $imageCarousel.parents( '.carousel-container' ).find( '.carousel-next' );
	const $imageCarouselPrevious = $imageCarousel.parents( '.carousel-container' ).find( '.carousel-previous' );
	const imageSwiper = new Swiper( imageCarouselElement, {
		loop: false,
		navigation: {
			nextEl: $imageCarouselNext[ 0 ],
			prevEl: $imageCarouselPrevious[ 0 ],
		},
		slidesPerView: 1.05,
		spaceBetween: 10,
		grabCursor: false,
		speed: 1000,
		allowTouchMove: true,
		breakpoints: {
			1024: {
				slidesPerView: 1.6,
				spaceBetween: 20,
				allowTouchMove: false,
				loop: true,
			},
		},
		on: {
			resize: updateCaptionSwiperWidth,
			realIndexChange: function( swiper ) {
				// $( swiper.el ).find( '.carousel-next' ).toggleClass( 'swiper-button-disabled', swiper.realIndex >= swiper.slides.length - 2 );

				if ( Math.abs( imageSwiper.realIndex - captionSwiper.realIndex ) > 1 ) {
					if ( imageSwiper.realIndex === 0 && captionSwiper.realIndex === swiper.slides.length - 1 ) {
						captionSwiper.slideNext();
					} else if ( captionSwiper.realIndex === 0 && imageSwiper.realIndex === swiper.slides.length - 1 ) {
						captionSwiper.slidePrev();
					} else {
						captionSwiper.slideToLoop( swiper.realIndex );
					}
				} else if ( imageSwiper.realIndex < captionSwiper.realIndex ) {
					captionSwiper.slidePrev();
				} else if ( imageSwiper.realIndex > captionSwiper.realIndex ) {
					captionSwiper.slideNext();
				} else {
					captionSwiper.slideToLoop( swiper.realIndex );
				}
			},
		},
	} );

	const $imageSwiperCursor = $( '<img class="opacity-0 transition-opacity duration-[400ms] carousel-cursor fixed pointer-events-none -translate-x-1/2 -translate-y-1/2 z-50">' );
	$( $imageCarousel ).append( $imageSwiperCursor );
	$imageCarouselPrevious
		.on( 'mouseenter', ( event ) => showImageSwiperCursor( ArrowLeft ) )
		.on( 'mousemove', updateImageSwiperCursorPosition )
		.on( 'mouseleave', hideImageSwiperCursor );
	$imageCarouselNext
		.on( 'mouseenter', ( event ) => showImageSwiperCursor( ArrowRight ) )
		.on( 'mousemove', updateImageSwiperCursorPosition )
		.on( 'mouseleave', hideImageSwiperCursor );

	function showImageSwiperCursor( url ) {
		$imageSwiperCursor.attr( 'src', url ).show().addClass( '!opacity-100' );
	}

	function hideImageSwiperCursor() {
		$imageSwiperCursor.hide().removeClass( '!opacity-100' );
	}

	function updateImageSwiperCursorPosition( event ) {
		$imageSwiperCursor.css( {
			left: event.clientX,
			top: event.clientY,
		} );
	}

	const captionSwiper = new Swiper( imageCaptionCarouselElement, {
		loop: true,
		direction: 'vertical',
		slidesPerView: 1,
		spaceBetween: 20,
		allowTouchMove: false,
		speed: 1000,
		on: {
			beforeInit: updateCaptionSwiperWidth,
			resize: updateSlidesHeightToHighestSlide,
			realIndexChange: updateCaptionSwiperWidth,
		},
	} );

	let slidersCount = $container.find('.real-slide').length;
	let $progressBar = $container.find( '.progress-bar' );

	$progressBar.css( { 'width': 100 / slidersCount + '%' } );

	imageSwiper.on( 'slideChange slideChangeTransitionEnd', function() {
		$progressBar.css( { 'width': (100 / slidersCount) * (this.activeIndex + 1) + '%' } );
	} );

	function updateCaptionSwiperWidth() {
		const containerWidth = $container.width();
		const smallSlideWidth = $( '.swiper-slide-active', imageCarouselElement ).outerWidth( true );
		$( imageCaptionCarouselElement ).parent().outerWidth( containerWidth - smallSlideWidth, true );
	}
} );

$( '.case-carousel' ).each( function() {
	var $this = $( this );

	var swiper = new Swiper( this, {
		slidesPerView: 1.1,
		spaceBetween: 10,
		grabCursor: true,
		breakpoints: {
			1024: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		},
	} );

	let slidersCount = swiper.slides.length;
	let $progressBar = $this.parents( '.carousel-container' ).find( '.progress-bar' );

	$progressBar.css( { 'width': 100 / slidersCount + '%' } );

	swiper.on( 'slideChange slideChangeTransitionEnd', function() {
		$progressBar.css( { 'width': (100 / slidersCount) * (this.activeIndex + 1) + '%' } );
	} );
} );

$( '.text-carousel-with-caption-container' ).each( function() {
	const $container = $( this );
	const $textCarousel = $( '.text-carousel', $container );
	const $textCarouselCaptions = $( '.carousel-captions', $container );

	const textCarouselElement = $textCarousel[ 0 ];
	if ( !textCarouselElement ) {
		return;
	}

	$( '.carousel-caption', $textCarouselCaptions ).click( function( event ) {
		event.preventDefault();
		swiper.autoplay.stop();
		swiper.slideToLoop( $( this ).index() );
	} );

	const swiper = new Swiper( textCarouselElement, {
		// direction: 'vertical',
		loop: true,
		allowTouchMove: false,
		autoHeight: true,
		autoplay: {
			delay: 7000,
		},
		speed: 700,
		spaceBetween: 50,
		on: {
			// resize: updateSlidesHeightToHighestSlide,
			realIndexChange: ( swiper ) => updateProgress( swiper, 0 ),
			autoplayTimeLeft: ( swiper, timeLeft, percentage ) => updateProgress( swiper, percentage ),
			autoplayStop: ( swiper ) => updateProgress( swiper, 0 ),
		},
	} );

	function updateProgress( swiper, percentage ) {
		$( '.carousel-caption-progress', $textCarouselCaptions )
			.each( function( index ) {
				const $this = $( this );
				const progressPercentage = (index === swiper.realIndex) ? -percentage * 100 : -100;
				$this.css( 'transform', `translate(${progressPercentage}%, 0)` );
			} );
		$( '.carousel-caption', $textCarouselCaptions )
			.each( function( index ) {
				const $this = $( this );
				$this.toggleClass( 'active', (index === swiper.realIndex) );
			} );
	}
} );

$( '.media-carousel' ).each( function() {
	var $this = $( this );

	var swiper = new Swiper( this, {
		loop: true,
		slidesPerView: 1,
		spaceBetween: 0,
		grabCursor: true,
		speed: 1000,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
			renderBullet: function( index, className ) {
				// Use Font Awesome icons for bullets
				return '<span class="' + className + '"><span class="fa-w-20 icon absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 fab fa-goldbox-star-filled"></span></span>';
			},
		},
		on: {
			init: ( swiper ) => {
				swiper.slides.forEach( ( slide, index ) => {
					if ( index > 0 ) {
						let video = slide.querySelectorAll( 'video' );

						if ( video ) {
							if ( !video.paused ) {
								video.pause;
							}
						}
					}
				} );
			},
			slideChange: ( swiper ) => {
				let activeSlide = swiper.slides[ swiper.activeIndex ];
				let videoElement = activeSlide.querySelector( "video" );
				let allVideos = swiper.el.querySelectorAll( 'video' );

				allVideos.forEach( function( video ) {
					if ( !video.paused ) {
						video.pause();
					}
				} );

				if ( videoElement ) {
					videoElement.play();
				}
			},
		},
	} );
} );

$( '.simple-image-carousel' ).each( function() {
	var $this = $( this );

	var swiper = new Swiper( this, {
		slidesPerView: 'auto',
		loopedSlides: 2,
		spaceBetween: 10,
		freeMode: false,
		allowTouchMove: false,
		speed: 8000,
		loop: true,
		autoplay: {
			delay: 0.5,
			disableOnInteraction: false,
		},
		breakpoints: {
			1024: {
				spaceBetween: 20,
			},
		},
	} );
} );

$( '.logo-carousel' ).each( function() {
	var $this = $( this );

	var swiper = new Swiper( this, {
		slidesPerView: 'auto',
		loopedSlides: 2,
		spaceBetween: 0,
		freeMode: false,
		allowTouchMove: false,
		speed: 4000,
		loop: true,
		autoplay: {
			delay: 0.5,
			disableOnInteraction: false,
		},
		breakpoints: {
			1024: {
				speed: 11000,
			},
		},
	} );
} );


$( '.image-fader' ).each( function() {
	var $this = $( this );

	var swiper = new Swiper( this, {
		slidesPerView: 1,
		spaceBetween: 0,
		effect: 'fade',
		allowTouchMove: false,
		autoHeight: true,
		on: {
			realIndexChange: function() {
				$( '.animated-pagination-button', $this ).each( function( i ) {
					$( this ).toggleClass( 'active', swiper.realIndex === i );
				} );
			},
		},
	} );
	$( '.animated-pagination-button', $this ).click( function( event ) {
		event.preventDefault();

		const $this = $( this );
		swiper.slideTo( $this.attr( 'data-slide-index' ) );
	} );
} );
